const ApiUrl = {
  getSurveyByToken: "/Surveys/GetSurveyByToken/",
  getSurveyClientByToken: "/Surveys/Client/",
  getCustomFieldsPublic: "Lookup/Candidate/CustomFieldsPublic",
  getJACountriesPublic: "/Lookup/Jobadder/CountriesPublic",
  getJAWorkTypesPublic: "/Lookup/Jobadder/WorkTypesPublic",
  getJACandidateStatusesPublic: "/Lookup/Jobadder/CandidateStatusesPublic",
  getJAClientStatusesPublic: "/Lookup/Jobadder/ClientStatusesPublic",
  getJASalutationsPublic: "/Lookup/Jobadder/SalutationsPublic",
  getJACompaniesPublic: "/Lookup/JobAdder/CompaniesPublic",
  submitSurvey: "/Surveys/SubmitSurvey/",
  submitSurveyClient: "/Surveys/Client/Submit/",

  getSkillCategoriesPublic: "/Lookup/Public/Skills/Categories",
  getSkillSubCategoriesPublic: "/Lookup/Public/Skills/SubCategories",
  getSkillsPublic: "/Lookup/Public/Skills",
};

export default ApiUrl;
